import React from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';

const GoogleMapComponent = ({ coordinates }) => {
  const style = { height: '60vh', width: '100%' };
  const parsedCoordinates = {
    lat: parseFloat(coordinates.latitude),
    lng: parseFloat(coordinates.longitude),
  };
  return (
    <LoadScript
      id='script-loader'
      googleMapsApiKey={process.env.GATSBY_GOOGLE_MAPS_API_KEY}>
      <GoogleMap
        id='circle-example'
        mapContainerStyle={style}
        zoom={15}
        center={parsedCoordinates}>
        <Marker position={parsedCoordinates} />
      </GoogleMap>
    </LoadScript>
  );
};

export default GoogleMapComponent;
